module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "center component"
  }, [_c('h1', [_vm._v("Tack för din betalning!")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Ditt bokningsnummer:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.reservationNumber))])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Betalmetod:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm.paymentMethod))])]), _vm._v(" "), _c('p', [_vm._v(" ")]), _vm._v(" "), _c('p', [_vm._v("Summa:")]), _vm._v(" "), _c('p', [_c('b', {
    staticStyle: {
      "font-size": "1.5em"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.paymentAmount)))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e69431f6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/PayedExternally.vue
// module id = 1015
// module chunks = 0